import Model, { attr } from '@ember-data/model';

export default class CreateUserModel extends Model {
  @attr('string') firstName?: string;
  @attr('string') lastName?: string;
  @attr('string') email?: string;
  @attr('string') role?: string;
  @attr() fundIds?: string[];
  @attr('string') referredByFirstName?: string;
  @attr('string') referredByLastName?: string;
  @attr('string') referredByEmail?: string;
  @attr('string') referredByOrganizationName?: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'admin/create-user': CreateUserModel;
  }
}
